import { useState } from "react";
import { Plus } from "lucide-react";

/** O "não achou?" dentro de cada categoria: o item novo já nasce nela, marcado. */
export function AdicionarNaCategoria({ categoria, onAdicionar }: { categoria: string; onAdicionar: (nome: string) => void }) {
  const [aberto, setAberto] = useState(false);
  const [nome, setNome] = useState("");
  const valido = nome.trim().length >= 2;
  const adicionar = () => {
    if (!valido) return;
    onAdicionar(nome.trim());
    setNome("");
  };

  if (!aberto) {
    return (
      <button
        type="button"
        onClick={() => setAberto(true)}
        className="flex min-h-[44px] items-center justify-center gap-1.5 rounded-lg border border-dashed border-zinc-300 px-3 py-2 text-xs font-semibold text-zinc-500 transition-colors hover:border-brand-300 hover:bg-brand-50/50 hover:text-brand-700 dark:border-border dark:text-muted-foreground dark:hover:bg-primary/10"
      >
        <Plus className="h-3.5 w-3.5" />
        Adicionar
      </button>
    );
  }
  return (
    <div className="col-span-2 flex items-center gap-1.5 rounded-lg border border-brand-300 bg-white p-1.5 sm:col-span-2 dark:border-primary/40 dark:bg-card">
      <input
        autoFocus
        value={nome}
        onChange={(e) => setNome(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") adicionar();
          if (e.key === "Escape") setAberto(false);
        }}
        placeholder={`Novo em ${categoria}`}
        aria-label={`Nome do novo item em ${categoria}`}
        className="h-8 min-w-0 flex-1 rounded-md border border-zinc-200 bg-white px-2.5 text-sm text-zinc-900 placeholder:text-zinc-400 focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500 dark:border-border dark:bg-card dark:text-foreground"
      />
      <button type="button" disabled={!valido} onClick={adicionar} className="h-8 shrink-0 rounded-md bg-brand-600 px-3 text-xs font-semibold text-white hover:bg-brand-700 disabled:opacity-50">
        Adicionar
      </button>
      <button type="button" onClick={() => setAberto(false)} className="h-8 shrink-0 rounded-md px-2 text-xs text-zinc-500 hover:bg-zinc-100 dark:text-muted-foreground dark:hover:bg-muted">
        Fechar
      </button>
    </div>
  );
}
